<template>
  <div>
    <Form ref="searchForm" inline :label-width="80" class="search-form">
      <Form-item label="日期范围">
        <DatePicker
          :value="timeRange"
          :editable="false"
          format="yyyy-MM-dd"
          type="daterange"
          @on-change="selectTime"
          placeholder="开始时间 - 结束时间"
          style="width:200px"
        ></DatePicker>
      </Form-item>
      <Form-item label="应用模块">
        <Select placeholder="请选择模块" v-model="searchCondition.module" style="width:200px" clearable>
          <Option v-for="item in modules" :value="item.id" :key="item.id">{{ item.value }}</Option>
        </Select>
      </Form-item>
      <Form-item label="属性名称">
        <Input
          style="width:240px"
          placeholder="请输入属性关键字"
          v-model="searchCondition.name"
          clearable
          @keydown.native.enter="search(1)"
        ></Input>
      </Form-item>
    </Form>
    <Form :label-width="80" inline>
      <Form-item label="属性值类型">
        <Select placeholder="请选择属性值类型" v-model="searchCondition.type" style="width:200px" clearable>
          <Option v-for="item in attrValTypes" :value="item.key" :key="item.key">{{ item.value }}</Option>
        </Select>
      </Form-item>
      <Form-item label="是否必填">
        <Select
          placeholder="请选择是否必填"
          v-model="searchCondition.is_required"
          style="width:200px"
          clearable
        >
          <Option
            v-for="item in attrValRequireds"
            :value="item.key"
            :key="item.key"
          >{{ item.value }}</Option>
        </Select>
      </Form-item>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <Button style="margin-right:20px;" type="primary" @click="add({},'新增属性')">添加属性</Button>
    <div class="content">
      <Grid
        ref="grid"
        :columns="column"
        data-url="/api/attribute"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        selectType="none"
      >
        <template slot-scope="{ row }" slot="action">
          <Button type="text" size="small" @click="goPage(row.id)">管理属性值</Button>-
          <Button type="text" size="small" @click="add(row,'编辑属性')">编辑</Button>-
          <Button type="text" size="small" @click="del('one',row.id)">删除</Button>
        </template>
      </Grid>
    </div>
    <!-- 新增/编辑属性 -->
    <Modal v-model="showModel" :title="modalTitle">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
        <FormItem label="属性名称" prop="name">
          <Input :maxlength="20" v-model="formValidate.name" placeholder="最多可输入20个字" clearable />
        </FormItem>
        <FormItem label="排序" prop="sort">
          <Input type="number" v-model="formValidate.sort" placeholder="请输入" clearable />
        </FormItem>
        <FormItem label="所属模块" prop="module">
          <CheckboxGroup v-model="formValidate.module">
            <Checkbox v-for="(item,index) in modules" :key="index" :label="item.id">{{item.value}}</Checkbox>
          </CheckboxGroup>
        </FormItem>
        <FormItem label="是否前端展示" prop="is_show_front">
          <RadioGroup v-model="formValidate.is_show_front">
            <Radio label="1">展示</Radio>
            <Radio label="0">不展示</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="属性值类型" prop="type">
          <RadioGroup v-model="formValidate.type">
            <Radio label="1">单选</Radio>
            <Radio label="2">多选</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="是否必选" prop="is_required">
          <RadioGroup v-model="formValidate.is_required">
            <Radio label="1">必填</Radio>
            <Radio label="2">选填</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="showModel = false">取消</Button>
        <Button type="primary" @click="save('formValidate')">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { AttrValType, AttrValRequired } from "@/utils/enums";
export default {
  name: "SettingAccount",
  data() {
    return {
      column: [
        {
          title: "ID",
          key: "id",
          minWidth: 80,
          align: "center"
        },
        {
          title: "属性名称",
          key: "name",
          minWidth: 150,
          align: "center"
        },
        {
          title: "属性值类型",
          key: "typeName",
          align: "center",
          minWidth: 100
        },
        {
          title: "是否必填",
          key: "isRequiredName",
          align: "center",
          minWidth: 100
        },
        {
          title: "属性值数量",
          key: "count",
          minWidth: 80,
          align: "center"
        },
        {
          title: "应用模块",
          key: "module",
          align: "center",
          minWidth: 150
        },
        {
          title: "创建人",
          key: "create_user",
          minWidth: 120,
          align: "center"
        },
        {
          title: "排序",
          key: "sort",
          minWidth: 70,
          align: "center"
        },
        {
          title: "创建日期",
          key: "created_at",
          align: "center",
          minWidth: 160
        },
        {
          title: "操作",
          slot: "action",
          minWidth: 180,
          align: "center",
          fixed: "right"
        }
      ],
      searchCondition: {
        start_at: "",
        end_at: "",
        name: "",
        module: ""
      },
      statusList: [],
      timeRange: ["", ""],
      showModel: false,
      modalId: "",
      modalTitle: "",
      modules: [],
      formValidate: {
        name: "",
        module: [],
        sort: "",
        is_show_front: "",
        type: "",
        is_required: ""
      },
      ruleValidate: {
        name: [
          {
            required: true,
            message: "属性名不能为空！"
          }
        ],
        sort: [
          {
            required: true,
            message: "请输入排序"
          }
        ],
        module: [
          {
            required: true,
            message: "请至少选择一个"
          }
        ],
        type: [
          {
            required: true,
            message: "请至少选择一个"
          }
        ],
        is_required: [
          {
            required: true,
            message: "请至少选择一个"
          }
        ],
        is_show_front: [
          {
            required: true,
            message: "请至少选择一个"
          }
        ]
      },
      attrValTypes: AttrValType.getOptions(),
      attrValRequireds: AttrValRequired.getOptions()
    };
  },
  methods: {
    // 格式化时间
    rowsFormatter(rows) {
      rows.forEach(i => {
        i.created_at = this.$pub.timestampToTime(i.created_at);
        i.typeName = AttrValType.getValue(i.type);
        i.isRequiredName = AttrValRequired.getValue(i.is_required || 2);
      });
    },
    search(flag) {
      if (flag == 0) {
        this.searchCondition.module = "";
        this.searchCondition.name = "";
        this.searchCondition.type = "";
        this.searchCondition.is_required = "";
        this.timeRange = ["", ""];
      }
      this.searchCondition.start_at = this.timeRange[0];
      this.searchCondition.end_at = this.timeRange[1];
      if (!this.searchCondition.module) this.searchCondition.module = "";
      this.$refs.grid.searchRefresh();
    },
    selectTime(e) {
      this.timeRange = e;
    },
    add(_data = {}, _title) {
      this.showModel = true;
      this.modalTitle = _title;
      this.modalId = _data.id || "";
      this.formValidate.name = _data.name || "";
      this.formValidate.module =
        this.$pub.mate(_data.module, this.modules) || [];
      this.formValidate.sort = _data.sort || "";
      this.formValidate.type = (_data.type || "") + "";
      this.formValidate.is_show_front = _data.is_show_front + "";
      this.formValidate.is_required = (_data.is_required || 2) + "";
    },
    /**
     * 新增/编辑属性
     */
    save(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.modalId != "") {
            // 编辑
            this.$http
              .put(`/api/attribute/${this.modalId}`, this.formValidate)
              .then(() => {
                this.search(1);
                this.showModel = false;
              });
          } else {
            //新增
            this.$http.post("/api/attribute", this.formValidate).then(() => {
              this.$refs.grid.getList();
              this.showModel = false;
            });
          }
        } else {
          this.$Message.error("请输入完整！");
          return;
        }
      });
    },
    del(_type, _id) {
      let ids = "";
      if (_type == "one") {
        ids = _id;
      } else {
        if (this.selectList.length == 0) {
          this.$Message.error("请至少选择一个属性");
          return false;
        } else {
          let arr = [];
          this.selectList.forEach(i => {
            arr.push(i.uid);
          });
          ids = arr.join(",");
        }
      }
      this.$Modal.confirm({
        title: "删除",
        content: "<p>确定要删除该属性吗？</p>",
        onOk: () => {
          this.delete(ids);
        },
        onCancel: () => {}
      });
    },
    delete(_ids) {
      this.$http.delete(`/api/attribute/${_ids}`).then(() => {
        this.search(1);
      });
    },
    getModule() {
      this.$http.get(`/api/modules`).then(res => {
        this.modules = this.$pub.toArray(res.modules);
      });
    },
    goPage(id) {
      this.$router.push({
        name: "AttrManager",
        query: {
          id: id
        }
      });
    }
  },
  created() {
    this.getModule();
  }
};
</script>
<style lang="scss" scoped>
.ivu-checkbox-wrapper {
  margin-right: 50px;
}
</style>
